// removed by extract-text-webpack-plugin
module.exports = {"featureImageQuoteContent":"_1KPD_SzL-sGX-os2A2jOPb","darkFilter":"_1_Blkz-4tJWaF-QofurA_A","quoteWrapper":"_3NOW1RRMZga40tgM2arziQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureImageQuoteContent/FeatureImageQuoteContent.module.scss
// module id = 759
// module chunks = 0